import { Divider } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { observer } from 'mobx-react-lite';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import React, { useContext, useState } from 'react';
import LoadingIndicator from '../common/LoadingIndicator';
import NoResultsText from '../common/NoResultsText';
import MobxContext from '../mobx/MobxContext';
import FamiliesTable from './FamiliesTable';
import Button from '@material-ui/core/Button';
import { Link, LinkProps } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1200,
      margin: 'auto'
    },
    header: { 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center' 
    },
    tabs: {
      marginBottom: 16
    },
    textFieldInput: {
      paddingTop: 12,
      paddingBottom: 12
    },
    toolbar: {
      marginBottom: 8
    },
    divider: {
      marginBottom: 16,
      marginTop: 8
    }
  })
);

function familyFilter(family, search) {
  return family.name.toLowerCase().includes(search) || family.owner.toLowerCase().includes(search);
}

const AdapterLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <Link innerRef={ref as any} {...props} />
));

function FamiliesPage(props: WithSnackbarProps) {
  const { enqueueSnackbar } = props;
  const classes = useStyles({});
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const { familyStore } = useContext(MobxContext);

  function onSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    setSearch(event.target.value);
    setPage(0);
  }

  function onToggleSubscription(family: any) {
    const subscribed = !family.subscribed;
    familyStore.toggleSubscription(family);
    enqueueSnackbar(subscribed ? 'Subscription added' : 'Subscription removed');
  }

  function onPageChange(newPage: number) {
    setPage(newPage);
  }

  const normalizedSearch = search.toLowerCase();

  const filteredFamilies = familyStore.families && normalizedSearch ? familyStore.families.filter(family => familyFilter(family, normalizedSearch)) : familyStore.families;

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h6">Families</Typography>
        <Button color="primary" variant="contained" component={AdapterLink} to="/families/new">New Family</Button>
      </div>
      <Divider className={classes.divider} light />
      <div className={classes.toolbar}>
        <TextField
          id="search"
          value={search}
          autoComplete="off"
          fullWidth
          margin="none"
          variant="outlined"
          placeholder="Search by family name or owner"
          inputProps={{ 'aria-label': 'bare', className: classes.textFieldInput }}
          onChange={onSearchChange}
        />
      </div>
      {filteredFamilies && filteredFamilies.length > 0 && <div><Paper>
        <FamiliesTable
          families={filteredFamilies}
          page={page}
          onPageChange={onPageChange}
          onToggleSubscription={onToggleSubscription}
        />
      </Paper></div>}
      {filteredFamilies && filteredFamilies.length === 0 && <NoResultsText>No families matching filter</NoResultsText>}
      <LoadingIndicator loading={!filteredFamilies} />
    </div>
  );
};

export default withSnackbar(observer(FamiliesPage));
